module.exports = __webpack_public_path__ + "static/media/gallery5.a94cb65a.jpg";